<template>
    <el-container>
        <el-header>
            <commonheader :isNavShow='true'></commonheader>
        </el-header>

        <el-container class="el-container-master">
            <el-aside style="width:220px">
                <leftMenu></leftMenu>
            </el-aside>
            <el-main>
                <section class="flex">
                    <exit></exit>
                    <div class="content exam" v-loading='loading'>
                        <examheader :qesList='qesList'></examheader>
                        <template v-if='isResult'>
                            <div class="qesType">
                                <span class='qesTypeText'>{{ qesType }}</span>
                                <div class="qesNum">
                                    <span>{{ activeIndex+1 }}</span>/
                                    <span>{{ qesList.length }}</span>
                                </div>
                            </div>
                            <div class="qesContent">
                                <el-carousel @change='qesChange' ref='carousel' :loop='false' :autoplay="false"
                                    arrow='never' indicator-position="none" :height='autoHeight+"px"'>
                                    <el-carousel-item v-for="item in qesList" :key="item.id">
                                        <div class="title">{{ item.title }}</div>
                                        <div class="qesList">
                                            <commonradio :list="item" :look='look' v-if='item.qtype == 1'
                                                @changeQes='changeQes' :selected='selected'></commonradio>
                                            <commoncheckbox :list="item" :look='look' v-else-if='item.qtype == 2'
                                                @changeQes='changeQes' :selected='selected'></commoncheckbox>
                                            <commonjudge :list="item" :look='look' v-else @changeQes='changeQes'
                                                :selected='selected'>
                                            </commonjudge>
                                        </div>
                                        <div class="btnGroup" :class="{'two' : look }">
                                            <span @click='prev' :class="{'active': activeIndex > 0}">上一题</span>
                                            <span @click="submitPapers" class='active' v-if='!look'>交卷</span>
                                            <span :class="{'active': activeIndex  < qesList.length-1 }"
                                                @click='next'>下一题</span>
                                        </div>
                                    </el-carousel-item>
                                </el-carousel>
                            </div>

                        </template>
                        <result v-else :right='right' :total='qesList.length'></result>

                    </div>
                    <common-confirm @sure='sure'></common-confirm>
                </section>
            </el-main>
        </el-container>
    </el-container>
</template>
<script>
import commonheader from "../../common/commonHeader.vue"; //头部组件
import leftMenu from "../../common/leftMenu.vue";
import exit from "../../common/exit.vue";
import examheader from "./examHeader.vue";
import commoncheckbox from "./checkbox.vue";
import commonradio from "./radio.vue";
import commonjudge from "./judge.vue";
import commonConfirm from "../../common/confirm.vue";
import result from "./result.vue";

export default {
    name: 'index',
    components: {
        commonheader,
        leftMenu,
        exit,
        examheader,
        commoncheckbox,
        commonradio,
        commonConfirm,
        commonjudge,
        result
    },
    data () {
        return {
            loading: true,
            activeIndex: 0,

            qesList: [],

            selected: {},
            qesType: '',

            pid: '',

            look: false,

            isResult: true,

            right: 0,

            autoHeight: 600
        }
    },
    watch: {
        activeIndex () {
            let qType = this.qesList[this.activeIndex].qtype;
            if (qType == 1) {
                this.qesType = '单选题';
            } else if (qType == 2) {
                this.qesType = '多选题';
            } else {
                this.qesType = '判断题';
            }
        }
    },
    mounted: function () {
        document.getElementsByTagName("html")[0].className = "my-page";
        if (this.$route.query.look) {
            this.look = true;
        }

        if (this.$route.query.pid) {
            this.pid = this.$route.query.pid;
        }

        this.getExamList();
    },
    methods: {
        /**
         * 获取试卷
         */
        getExamList () {
            let param = {
                type: this.$route.query.type,
                year: this.$route.query.year,
            };
            if (this.pid) {
                param['pid'] = this.pid;
            }

            this.$store.dispatch('getExam', param).then((res) => {
                for (let i in res.data.questions) {
                    // this.activeIndex = res.data.questions[0].qtype;
                    res.data.questions[i].userOptions = res.data.questions[i].options.split(/[\n,]/g);
                }
                this.pid = res.data.pid;
                this.qesList = res.data.questions;

                //如果是查看进来的
                if (this.look) {
                    this.initSelected();
                }

                if (!this.look) {
                    this.initConintueSelected();
                }

                let qtype = res.data.questions[0].qtype;
                if (qtype == 1) {
                    this.qesType = '单选题';
                } else if (qtype == 2) {
                    this.qesType = '多选题';
                } else {
                    this.qesType = '判断题';
                }

                this.loading = false;
            }).catch((error) => {
                this.$router.push('/examList')
                this.loading = false;
            })
        },
        /**
         * 查看进来初始化答过的数据
         */
        initSelected () {
            let obj = {};
            this.qesList.map((item, index) => {
                obj[item.qid] = item.user_answer;
            })
            this.selected = obj;
            this.$set(this.selected, this.selected)

        },

        /**
         * 继续答题进来初始化答过的数据
         */
        initConintueSelected () {

            setTimeout(() => {
                let local = localStorage.getItem(this.pid + 'selected');
                if (local) {
                    this.selected = JSON.parse(local)
                }
            }, 10)

            let page = localStorage.getItem(this.pid + 'currentPage', this.activeIndex);
            if (page) {
                setTimeout(() => {
                    this.$refs.carousel.setActiveItem(page);
                }, 10)
            }

        },

        /**
         * 确定交卷
         */
        sure () {
            this.right = this.getRightNum();
            let params = {
                pid: this.pid,
                right: this.right,
                questions: this.getQuestions()
            }
            // return false;
            this.$store.dispatch('exam_record', params).then((res) => {
                this.isResult = false;
            })
        },
        /**
         * 判断答对的数量
         */
        getRightNum () {
            let num = 0;
            for (let i in this.selected) {

                this.qesList.map((item, idx) => {

                    if (i == item.qid) {
                        if (this.selected[i] == item.answer) {
                            num++;
                        }
                        return;
                    }
                })
            }
            return num;
        },
        /**
         * 获取用户答案拼装到list
         */
        getQuestions () {
            this.qesList.map((item, idx) => {
                delete item.userOptions;
                if (this.selected[item.qid]) {
                    item.user_answer = this.selected[item.qid];
                } else {
                    item.user_answer = '';
                }
            })
            return JSON.stringify(this.qesList);
        },
        /**
         * 点击选项的时候
         */
        changeQes (obj) {
            var arr = Object.keys(obj);
            this.$set(this.selected, arr[0], obj[arr[0]])
            this.selected[arr[0], obj[arr[0]]]
            this.$set(this.selected, this.selected)
            localStorage.setItem(this.pid + 'selected', JSON.stringify(this.selected));
        },
        next () {
            this.$refs.carousel.next();
        },
        prev () {
            this.$refs.carousel.prev();
        },
        qesChange () {
            this.activeIndex = this.$refs.carousel.activeIndex;

            localStorage.setItem(this.pid + 'currentPage', this.activeIndex);

            let height = this.qesList[this.activeIndex].userOptions.length * 30;
            this.autoHeight = (height < 400 ? 400 : height) + 288;

        },
        submitPapers () {
            let target = {
                public_model_show: true,
                public_model_text: '您是否确认交卷',
                public_model_param: {}
            }
            this.$store.commit("show_public_model", target);
        }
    }
}
</script>

<style lang="stylus" scoped>
@media (min-width: 1399px)
    .el-container-master
        width 1400px
        margin auto
.el-aside
    background #fff
.el-main
    padding 0
    background #fff
.content
    padding 47px 32px 29px 40px
    flex 1
    border-top 10px solid #F8F8F8
    border-left 10px solid #F8F8F8
    padding-bottom 50px
    .qesType
        position relative
        text-align center
        margin 30px 0 50px
        .qesTypeText
            color $textColorGray
            font-size 18px
        .qesNum
            color $textColorGray
            font-scale 14px
            position absolute
            right 10px
            top 0
    .title
        margin-bottom 50px
        font-size 18px
    .btnGroup
        width 385px
        line-height 26px
        padding 16px 0
        cursor pointer
        z-index 5
        // position fixed
        left 0
        right 0
        bottom 47px
        margin 30px auto
        // transform translateX(110px)
        background-image url('~@/assets/images/examBtnBg.png')
        background-size 100% 100%
        span
            width 120px
            font-size 16px
            text-align center
            color $textColorGray
            border-right 1px solid #D1D1D1
            display inline-block
            &:last-child
                border-right 0
        .active
            color #333333
    .btnGroup.two
        width 249px
</style>

<style lang="stylus">
.answerBox
    width 376px
    background #F8F8F8
    padding 48px 0
    margin auto
    p
        color #333333
        font-size 16px
        text-align center
.el-radio__input.is-disabled.is-checked .el-radio__inner::after
    background none !important
.el-radio__input.is-disabled .el-radio__inner
    background-color transparent!important
.el-radio__input.is-disabled+span.el-radio__label
    color #4d4d4d
.el-checkbox__input.is-disabled .el-checkbox__inner::after
    border-color transparent!important
.el-checkbox__input.is-disabled+span.el-checkbox__label
    color #606266
.el-radio__input.is-disabled .el-radio__inner, .el-radio__input.is-disabled.is-checked .el-radio__inner
    background-color transparent
.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after
    border-color transparent
.el-carousel__container
    height auto
</style>


// WEBPACK FOOTER //
// src/components/my/exam/index.vue